/**
 * Shared sx constants for plan carousel cards.
 * Used by ChangePlan, ChangeSponsorPlan, SelectPaymentPackage, and SelectPaymentPackageSponsor.
 *
 * cardWrapperSx / cardInnerSx — edit subscription cards (flex: 1 fills parent height)
 * cardInnerNoStretchSx — create profile cards (natural height, no flex stretch)
 */

export const cardWrapperSx = {
  width: "100%",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
};

export const cardInnerSx = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "relative",
  flex: 1,
  minHeight: 0,
};

export const cardInnerNoStretchSx = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "relative",
};

/** Blue radial gradient on active card header, white on inactive */
export const gradientHeaderSx = (isActive) => ({
  padding: {
    xs: "10px",
    xl: "10px 20px",
  },
  background: isActive
    ? "radial-gradient(42.29% 120.59% at 50% 0%, #004499 0%, #051A5B 100%)"
    : "#fff",
});

export const priceBadgeSx = (isActive) => ({
  padding: "4px 10px",
  backgroundColor: isActive ? "#F1F7FA24" : "#F1F7FAB2",
  color: isActive ? "#fff" : "#000",
  borderRadius: "20px",
  fontWeight: 600,
  fontSize: {
    xs: "12px",
    sm: "14px",
    xl: "16px",
  },
  display: "inline-block",
});

export const activeBadgeSx = {
  padding: "4px 8px",
  backgroundColor: "#ffffff",
  color: "#2A4876",
  borderRadius: "20px",
  fontWeight: 600,
  fontSize: {
    xs: "12px",
    sm: "14px",
    xl: "16px",
  },
  display: "inline-block",
};

/** Feature list text — smaller on active card so more items fit without scrolling */
export const featureTextSx = (isActive) => ({
  margin: 0,
  fontWeight: 400,
  fontSize: {
    xs: isActive ? "14px" : "16px",
    md: isActive ? "16px" : "18px",
    xl: isActive ? "18px" : "20px",
  },
  color: "#000000B2",
});

export const actionButtonSx = {
  width: "60%",
  backgroundColor: "#2A4876",
  borderRadius: "100px",
  height: "50px",
  borderColor: "#2A4876",
  color: "#ffffff",
  fontSize: "18px",
  fontWeight: 400,
  textTransform: "capitalize",
  boxShadow: "none",
  marginBottom: "15px",
};

export const featureListContainerSx = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: 0,
};
